import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield, ShieldCheck, ChevronRight } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

export const SecurityMfaCard = ({ user }) => {
  const navigate = useNavigate();

  return (
    <Card>
      <CardHeader>
        <CardTitle>Seguranca da Conta</CardTitle>
        <CardDescription>
          Proteja a sua conta com autenticacao multi-fator (MFA)
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div
          className="flex items-center justify-between p-4 bg-slate-50 rounded-lg cursor-pointer hover:bg-slate-100 transition-colors"
          onClick={() => navigate('/mfa-setup')}
          data-testid="mfa-settings-link"
        >
          <div className="flex items-center gap-4">
            <div className={`w-10 h-10 rounded-full flex items-center justify-center ${user?.mfa_enabled ? 'bg-emerald-100' : 'bg-amber-100'}`}>
              {user?.mfa_enabled ? (
                <ShieldCheck className="w-5 h-5 text-emerald-600" />
              ) : (
                <Shield className="w-5 h-5 text-amber-600" />
              )}
            </div>
            <div>
              <h4 className="font-medium text-slate-900">Autenticacao Multi-Fator (MFA)</h4>
              <p className="text-sm text-slate-500">
                {user?.mfa_enabled
                  ? 'Ativado - A sua conta esta protegida'
                  : 'Desativado - Adicione uma camada extra de seguranca'}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Badge variant={user?.mfa_enabled ? 'default' : 'secondary'} className={user?.mfa_enabled ? 'bg-emerald-500' : ''}>
              {user?.mfa_enabled ? 'Ativo' : 'Inativo'}
            </Badge>
            <ChevronRight className="w-5 h-5 text-slate-400" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
